{
  "Nav": {
    "MakePayments": "Hacer pagos",
    "SendMoney": "Enviar dinero",
    "SignUp": "Regístrate",
    "LogIn": "Iniciar sesión"
  },
  "Hero": {
    "Chip": "La plataforma de pagos con IA",
    "TitleLine1": "Facturas de propiedades transfronterizas,",
    "TitleLine2Lead": "Pagadas ",
    "TitleLine2Accent": "Inteligentemente.",
    "Subtitle": "Facturación automatizada + pagos del hogar para administradores de propiedades, proveedores y los clientes a quienes sirven —",
    "SubtitleBold": "todo en un solo lugar.",
    "PrimaryCta": "Regístrate hoy",
    "SecondaryCta": "Agendar demo"
  },
  "Diagram": {
    "PropertyManagers": "Administradores",
    "HOAs": "HOAs",
    "Vendors": "Proveedores",
    "Contractors": "Contratistas",
    "AI": "IA",
    "TimeSaved": "Tiempo ahorrado",
    "Homeowners": "Propietarios"
  },
  "Banner": {
    "Text": "¿Necesitas enviar dinero a amigos y familiares?",
    "Link": "Prueba Sendola Pay"
  },
  "Tabs": {
    "WhoWeServe": "¿A quién servimos?",
    "WhoWeCanPay": "¿A quién podemos pagar?",
    "ConciergeService": "Servicio Concierge",
    "PricingSavings": "Precios + Ahorros",
    "FrequentQA": "Preguntas frecuentes"
  },
  "EverythingYouNeed": {
    "Title": "Todo lo que necesitas saber"
  },
  "WhoWeServe": {
    "Title": "Hecho para la propiedad moderna",
    "Card1Title": "Propietarios estadounidenses",
    "Card1Desc": "con inversiones inmobiliarias en comunidades de lujo, que necesitan pagar a administradores de propiedades, personal y proveedores locales.",
    "Card2Title": "Proveedores y prestadores de servicios",
    "Card2Desc": "que requieren transacciones globales confiables y pagos puntuales en México.",
    "Card3Title": "Empresas de administración de propiedades",
    "Card3Desc": "que manejan desembolsos mensuales de alto valor para mantenimiento, servicios públicos y personal doméstico.",
    "Card4Title": "Family offices y asesores financieros",
    "Card4Desc": "que buscan consolidar y automatizar sus pagos internacionales relacionados con propiedades."
  },
  "WhoWeCanPay": {
    "Title": "Comunidades que usan Sendola hoy",
    "Desc": "Con la confianza de comunidades exclusivas y propietarios en los destinos más codiciados del mundo. Nos expandimos a nuevos mercados cada mes.",
    "SupportTitle": "Soportamos pagos a",
    "CounterNumber": "40+",
    "CounterLabel": "países",
    "SupportDesc": "Y expandiéndonos continuamente a nuevos destinos y comunidades en todo el mundo.",
    "BottomText": "Si tu propiedad está en otro lugar y te gustaría usar Sendola, contáctanos. Es posible que ya soportemos tu región o podamos explorar agregarla próximamente."
  },
  "WhoWePay": {
    "Title": "¿A quién pagamos?",
    "Col1Title": "HOAs y comunidades residenciales",
    "Col1Desc": "Paga cualquier cuota de HOA o comunidad residencial, incluyendo:",
    "Col1Item1": "Cuotas mensuales y de mantenimiento",
    "Col1Item2": "Gastos de propiedad",
    "Col2Title": "Servicios públicos y energía",
    "Col2Desc": "Pagos de electricidad, gas y servicios relacionados:",
    "Col2Item1": "CFE",
    "Col2Item2": "Engie Maxigas",
    "Col2Item3": "Naturgy",
    "Col2Item4": "Cuotas mensuales y de mantenimiento",
    "Col3Title": "Otros servicios",
    "Col3Desc": "Gestiona todos los pagos de agua en múltiples regiones:",
    "Col3Item1": "AGUAKAN - Cancún",
    "Col3Item2": "SACMEX (Ciudad de México)",
    "Col3Item3": "SIAPA (Guadalajara)",
    "Col3Item4": "SEAPAL (Puerto Vallarta)",
    "Col3Item5": "Otros proveedores locales",
    "Col4Title": "Internet, TV y telecomunicaciones",
    "Col4Desc": "Paga conectividad, streaming y servicios de cable:",
    "Col4Item1": "SKY",
    "Col4Item2": "Totalplay",
    "Col4Item3": "Megacable",
    "Col4Item4": "Izzi Telecom",
    "Col4Item5": "DISH",
    "Col5Title": "Entretenimiento y servicios digitales",
    "Col5Desc": "Administra todas las suscripciones digitales y del hogar:",
    "Col5Item1": "Netflix",
    "Col5Item2": "VIX Premium",
    "Col5Item3": "Paramount+",
    "Col5Item4": "Prime Video",
    "Col5Item5": "y más"
  },
  "Concierge": {
    "Title": "Servicio Concierge",
    "CardTitle1": "Soporte Global,",
    "CardTitle2": "Bajo Demanda",
    "CardDesc": "Recibe soporte dedicado de expertos financieros comprometidos con tu éxito global.",
    "SaferTitle": "Una forma más segura de hacer pagos internacionales",
    "SaferDesc": "Sendola Pay opera bajo un sólido marco regulatorio para garantizar el cumplimiento de las leyes locales y las mejores prácticas internacionales contra el lavado de dinero."
  },
  "Pricing": {
    "CardLabel": "PRECIO TODO INCLUIDO EN FX",
    "CardHeadline": "Claro, fijo y totalmente transparente antes de la ejecución",
    "CardFooter": "Los precios reflejan costos reales de acceso al mercado y condiciones de liquidez, sin spreads ocultos.",
    "Title": "Transparencia en precios",
    "DescStart": "Cada transacción se ",
    "DescBold": "cotiza por adelantado con un tipo de cambio final.",
    "DescEnd": " Lo que apruebas es exactamente lo que se liquida.",
    "Tag1": "Tipo de cambio anticipado",
    "Tag2": "Sin comisiones ocultas",
    "Tag3": "Liquidación predecible"
  },
  "LevelUp": {
    "TitleLine1": "¿Listo para mejorar tu",
    "TitleLine2": "experiencia de pagos?",
    "Cta": "Regístrate hoy"
  },
  "ClientsSay": {
    "Title": "Lo que dicen nuestros clientes",
    "Client1Name": "WORK WORLD JOBS",
    "Client1Quote": "Sendola es una solución segura y confiable para pagos internacionales. Las transacciones son rápidas y fluidas, y su soporte profesional los convierte en un socio de confianza para nuestras necesidades globales.",
    "Client1Stars": "4",
    "Client2Name": "MARAVILLA SFC LLC",
    "Client2Quote": "Respuestas rápidas, un proceso fácil y una experiencia general fluida. La transacción se completó de manera eficiente y con gran soporte.",
    "Client2Stars": "5",
    "Client3Name": "EL DORADO GOLF & BEACH CLUB",
    "Client3Quote": "El servicio al cliente de Sendola se destaca. El equipo es profesional, conocedor y genuinamente enfocado en resolver problemas rápidamente.",
    "Client3Stars": "5",
    "Client4Name": "COSTA BRAVA HOA",
    "Client4Quote": "Sendola es una solución segura y confiable para pagos internacionales. Las transacciones son rápidas y fluidas, y su soporte profesional los convierte en un socio de confianza para nuestras necesidades globales.",
    "Client4Stars": "4"
  },
  "Testimonial": {
    "Quote": "\u201CComo profesional inmobiliario, Sendola ha transformado la forma en que manejamos los pagos internacionales, ahorrándonos incontables horas y reduciendo costos significativamente\u201D",
    "Author": "-Director de Administración de Propiedades, Los Cabos-"
  },
  "Footer": {
    "Solutions": "Soluciones",
    "MakePayments": "Realizar pagos - Para empresas",
    "SendMoney": "Enviar dinero - Para individuos",
    "Pricing": "Precios",
    "WhoWePay": "¿A quién pagamos?",
    "UseCases": "Casos de uso",
    "ConciergeService": "Servicio Concierge",
    "Faqs": "Preguntas frecuentes",
    "LegalInformation": "Información legal"
  },
  "Faq": {
    "Title": "Preguntas Frecuentes",
    "Cta": "Agendar demo",
    "Q1": "¿Qué es Sendola?",
    "A1": "Sendola es una empresa que facilita pagos globales desde Estados Unidos de forma simple y segura. Sendola está registrada en Estados Unidos, cuenta con oficinas en Scottsdale, Arizona, y no es una institución bancaria.",
    "Q2": "¿En qué países puedo realizar mis pagos?",
    "A2": "Con Sendola puedes realizar pagos a México, Canadá, Centroamérica, Sudamérica, Europa, Asia y Oceanía. Si necesitas confirmar si un país específico está disponible, nuestro equipo puede ayudarte.",
    "Q3": "¿Cuánto tiempo tarda una transacción en completarse?",
    "A3": "Los pagos recibidos en días hábiles antes de las 2:00 p.m. (CT) comienzan a procesarse el mismo día. Los depósitos recibidos después de ese horario, así como en fines de semana o días festivos, se procesan el siguiente día hábil.",
    "Q4": "¿Desde qué lugares tengo permitido realizar mis pagos?",
    "A4": "Los envíos de dinero con Sendola pueden realizarse desde cualquier estado de los Estados Unidos.",
    "Q5": "¿Con qué documentos puedo realizar mi validación de identidad en el proceso de alta?",
    "A5": "Para completar tu registro en Sendola, necesitarás contar con un pasaporte vigente.",
    "Q6": "¿Qué necesito registrar para realizar pagos a nombre de mi empresa?",
    "A6": "Para realizar pagos a nombre de tu empresa, solicitamos información básica de la empresa y de sus representantes legales. Los documentos específicos se solicitarán directamente durante el proceso de registro o a través de nuestro equipo de soporte, según el caso.",
    "Q7": "¿Cómo me informan que ya completé mi proceso de alta y puedo realizar pagos?",
    "A7": "Una vez que completes tu proceso de validación, recibirás una notificación confirmando el estatus de tu alta. Recibirás un correo electrónico informándote que tu cuenta ha sido aprobada. Al ingresar a la plataforma, verás un mensaje de confirmación indicando que ya puedes realizar tus envíos de dinero.",
    "Q8": "¿Qué métodos de pago puedo usar?",
    "A8": "Por el momento, los envíos de dinero con Sendola se realizan mediante transferencia bancaria (Wire) desde una cuenta en USD.",
    "Q9": "¿Qué información requiero para registrar a un beneficiario?",
    "A9": "Para registrar a un beneficiario en México, necesitarás proporcionar información básica que nos permita validar su identidad y su cuenta bancaria, como: nombre del beneficiario, dirección del beneficiario, documento oficial de identificación, datos de la cuenta bancaria (CLABE o carátula bancaria), teléfono y correo electrónico de contacto. Si el beneficiario es una empresa, puede ser necesario proporcionar información adicional.",
    "Q10": "Para México, ¿a qué bancos puedo realizar mi pago?",
    "A10": "Sendola puede realizar pagos a la mayoría de los bancos que forman parte del Sistema Financiero Mexicano.",
    "Q11": "¿Cómo puedo consultar el recibo de mi operación?",
    "A11": "Una vez que tu operación haya sido completada, recibirás un recibo por correo electrónico y también podrás descargarlo directamente desde la plataforma.",
    "Q12": "¿Cómo me puedo comunicar con Servicio a Cliente de Sendola?",
    "A12": "En Sendola estamos disponibles para ayudarte con cualquier duda o consulta. Puedes comunicarte con nosotros a través de correo electrónico a concierge@sendola.com o desde nuestra página de Contacto, donde puedes llamarnos directamente o programar una reunión con nuestro equipo.",
    "Q13": "¿Sendola permite envíos domésticos dentro de EE.UU.?",
    "A13": "No. Actualmente, Sendola sólo realiza pagos internacionales a los destinos previamente enlistados, incluyendo el pago de servicios y otros gastos en el extranjero.",
    "Q14": "¿Una vez que realicé mi wire, cuánto tiempo tarda en reflejarse?",
    "A14": "Una vez que completes tu proceso de registro, las transacciones pueden tardar hasta 36 horas hábiles en completarse, dependiendo del horario en que recibamos tu depósito y de los procesos de validación.",
    "Q15": "¿El tipo de cambio es fijo?",
    "A15": "El tipo de cambio puede variar debido a las fluctuaciones del mercado cambiario. Aunque Sendola busca ofrecer un tipo de cambio estable durante el día, en algunos casos pueden presentarse movimientos que requieran una actualización de la cotización. Cuando esto suceda, te informaremos y te ofreceremos un tipo de cambio actualizado."
  },
  "Legal": {
    "Title": "Información Legal",
    "Address": "Sendola Corp. 6710 E. Camelback Rd, Scottsdale, AZ 85253, U.S.A.",
    "Bullet1": "Términos y condiciones de servicio",
    "Bullet2": "Política de privacidad",
    "Bullet3": "Política de conservación de datos",
    "Bullet4": "Política de seguridad de la información",
    "Bullet5": "Acuerdo de divulgación y comunicaciones electrónicas",
    "Bullet6": "Aviso sobre la Ley USA PATRIOT",
    "Bullet7": "Anexo de Producto — Servicios de Pago de Facturas de Propiedad",
    "SEOTitle": "Información Legal | Sendola — Para Propietarios"
  },
  "Contact": {
    "HeadingTitle": "Contacta a nuestro equipo",
    "HeadingSubtitle": "Hablemos sobre cómo Sendola puede simplificar los pagos de tu propiedad",
    "Questions": "Ya sea que tengas preguntas, quieras ver una demostración o necesites ayuda para comenzar, nuestro equipo está aquí para ti.",
    "ContactCards": {
      "Card1": {
        "Title": "Llámanos",
        "Text": "¿Prefieres hablar directamente?\nEstamos a solo una llamada de distancia.",
        "Button": "+1 (520) 342-0520"
      },
      "Card2": {
        "Title": "Programa una reunión",
        "Text": "Elige un horario que te convenga",
        "Button": "Programar una llamada"
      }
    },
    "WeAreHere": "Estamos aquí para ayudarte",
    "Available": "Disponible de lunes a viernes, de 9 a. m. a 6 p. m. PST",
    "SEOTitle": "Contáctanos | Sendola — Para Propietarios"
  },
  "ComingSoon": {
    "Title": "Muy Pronto",
    "Body": "Estamos dando los toques finales a esta funcionalidad. Mientras tanto, nuestro equipo puede ayudarte con el pre-registro o nuestro servicio concierge.",
    "Cta": "Contacta a nuestro equipo"
  },
  "SEO": {
    "Title": "Sendola — Gestión de pagos de propiedades para propietarios en México",
    "Description": "Administra cuotas de HOA, servicios públicos, facturas de proveedores y servicios recurrentes para tu propiedad en México. Todo en un solo lugar seguro."
  }
}
